<template>
    <modal size="lg" ref="modal" :hasFooter="false"><span slot="title" v-if="location">{{ location.name }}</span>
        <div class="row" v-if="location">
            <div class="col-5">
                <p>Address: {{ location.address }}</p>
                <p>Region: {{ location.region ? location.region.name : 'none' | capitalize }}</p>
            </div>
            <div class="col-7">
                <gmap-map class="map border" :zoom="location.zoom" :center="position">
                    <gmap-marker :position="position" :clickable="true" :draggable="true"></gmap-marker>
                </gmap-map>
                <div class="d-flex justify-content-around mt-2">
                    <div class="small">latitude: {{ location.latitude }}</div>
                    <div class="small">longitude: {{ location.longitude }}</div>
                    <div class="small">zoom: {{ location.zoom }}</div>
                </div>
            </div>
        </div>
        <div class="row" v-if="location">
            <h4 class="mt-3 ml-3" v-if="hasIntegrations">Integrations</h4>
        </div>
        <div class="row" v-if="location">
            <div class="col-md-4" v-if="hasforeUp"><img class="foreup-logo my-3" src="/img/foreup-logo.png"
                                                        alt="ForeUp"/>
                <p class="ml-2">Couse Name: {{ foreUp.course_name }}</p>
                <p class="ml-2">Course City: {{ foreUp.course_city }}</p>
                <p class="ml-2">Course State: {{ foreUp.course_state }}</p>
            </div>
            <div class="col-md-3" v-if="hasFacebook"><img class="facebook-logo my-3" src="/img/facebook-logo-2.png"
                                                          alt="Facebook"/>
                <p class="ml-2">Webpage Name: {{ facebook.name }}</p>
                <p class="ml-2">Logo:<img class="align-self-center ml-3" :src="facebook.picture"
                                          style="max-width: 60px"/></p>
            </div>
        </div>
        <div class="row" v-if="hasReviews">
            <h4 class="mt-3 ml-3">Review Links</h4>
        </div>
        <div class="row" v-if="hasReviews">
            <div class="col-4" v-for="review in reviewLinks" :key="review.source">
                <sites-review-card class="mb-3" :title="review.source" :url="review.url"></sites-review-card>
            </div>
        </div>
    </modal>
</template>

<script>
    export default {
        props: {
            locationDetails: {default: () => ({})},
        },
        data: () => ({
            schedules: ['Complete', 'Completed', 'Fixed'],
            location: null,
        }),
        watch: {
            locationDetails() {
                this.location = this.locationDetails;
            }
        },

        computed: {
            position() {
                return {lat: this.location.latitude, lng: this.location.longitude};
            },
            hasforeUp() {
                return this.foreUp !== null;
            },
            foreUp() {
                return this.location.foreup_credential;
            },
            hasFacebook() {
                return this.facebook !== null;
            },
            hasReviews() {
                if (this.reviewLinks) {
                    if (this.reviewLinks.length > 0) {
                        return true;
                    }
                }
                return false;
            },
            facebook() {
                return this.location.facebook_page;
            },
            hasIntegrations() {
                return this.hasFacebook === true || this.hasforeUp === true;
            },
            reviewLinks() {
                if (this.location) {
                    return [
                        {source: 'yelp', url: this.location.write_review_yelp_url},
                        {source: 'google', url: this.location.write_review_google_url},
                        {source: 'facebook', url: this.location.write_review_facebook_url},
                        {source: 'trip_advisor', url: this.location.write_review_trip_advisor_url},
                        {source: 'capterra', url: this.location.write_review_capterra_url},
                        {source: 'software_advice', url: this.location.write_review_software_advice_url},
                        {source: 'g2_crowd', url: this.location.write_review_g2_crowd_url},
                        {source: 'golf_now', url: this.location.write_review_golf_now_url}
                    ].filter(review => review.url);
                }
            },
        },
        methods: {
            open() {
                this.$refs.modal.open();
            },
            close() {
                this.$refs.modal.close();
            },
        },
    };
</script>

<style scoped>
    .foreup-logo {
        width: 100px;
    }

    .facebook-logo {
        width: 137px;
    }
</style>
